/**
 * @deprecated use ukLocale
 */
export const mappedLocales = {
  uk: 'en-GB',
  fr: 'fr-FR',
  es: 'es-ES',
  de: 'de-DE',
} as const;

export const ukLocale = 'en-GB';
export type MappedLocales = typeof mappedLocales;
export type MappedLocale = MappedLocales[keyof MappedLocales];
